import Cookies from "js-cookie"; /* function used to get configit session id
from cookie. The cookie expires in 29 minutes 50 seconds
*/
export var getConfigITApiSessionId = function () { return getCookie('ace-platform-session-id', 1790); }; /**
 *
 * @param cookieName
 * @returns sessionid for configit session
 */
function getCookie(cookieName, expirationInSeconds) {
    var cookieValue = Cookies.get(cookieName);
    if (cookieValue) { // Cookie exists and is not expired        
        return cookieValue;
    }
    else {
        var sessionId = generateGUID();
        var now = new Date();
        var expiryDate = new Date(now.getTime() + expirationInSeconds * 1000);
        Cookies.set(cookieName, sessionId, { expires: expiryDate });
        return sessionId;
    }
} /**
 *
 * @returns a unique guid
 */
function generateGUID() { return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; var v = c === 'x' ? r : r & 0x3 | 0x8; return v.toString(16); }); }
